import React, { useEffect, useState } from 'react';
import { TitledVerticalFlexLayout } from '../../features/shared/components/VerticalFixedLayout/VerticalFixedLayout';
import { useQuery } from '@tanstack/react-query';
import { coreService } from '../../services/core/core-service';
import { Flex, Spin, Tag, Tooltip } from 'antd';
import { ManualClipsFiltersBar } from '../../features/clips/components/FiltersBar';
import { NoClipMessage } from '../../features/clips/components/NoClipMessage';
import { ManualClipCard } from '../../features/recap/components/ManualClipCard';
import { useClipEventStore } from '../../features/recap/store/clip.store';
import { sub } from 'date-fns';

type Filters = {
  search?: string;
  from?: Date;
  to?: Date;
};

export const Clips: React.FC = () => {
  const { subscribe } = useClipEventStore();

  const [filters, setFilters] = useState<Filters>({
    search: '',
    from: sub(new Date(), { days: 7 }),
    to: new Date(),
  });

  const fromKey = filters.from ? filters.from.toISOString().split('T')[0] : undefined;
  const toKey = filters.to ? filters.to.toISOString().split('T')[0] : undefined;

  const {
    data: clips,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ['clips', filters.search, fromKey, toKey],
    queryFn: () => coreService.getUserClips(filters),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  useEffect(() => {
    const unsubscribe = subscribe('refreshClips', () => {
      refetch();
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <TitledVerticalFlexLayout
      title={
        <Flex gap={8} align="center">
          <span>My Clips</span>
          <Tooltip title="Currently in Beta — share any and all feedback to concierge@update.ai">
            <Tag color="red">Beta</Tag>
          </Tooltip>
        </Flex>
      }
    >
      <ManualClipsFiltersBar onChange={setFilters} />

      <Flex
        style={{ width: '100%', height: 'calc(100% - 100px)', marginTop: 24, overflow: 'auto' }}
        vertical
      >
        <Flex justify="center" align="center" style={{ height: '100%', width: '100%' }}>
          {isFetching && <Spin />}

          {!isFetching && clips && clips.length === 0 && <NoClipMessage />}
        </Flex>

        {!isFetching && clips && (
          <div>
            <Flex gap={8} wrap>
              {clips?.map((clip: any) => (
                <ManualClipCard
                  key={clip.id}
                  clip={clip}
                  showOwner={false}
                  showDeleteButton={true}
                />
              ))}
            </Flex>
          </div>
        )}
      </Flex>
    </TitledVerticalFlexLayout>
  );
};
